<template>
  <div class="login-container">
    <div class="login-box">
      <h2 class="login-box-title">登陆</h2>
      <el-form
        :model="userInfo"
        ref="dynamicValidateForm"
        label-width="100px"
        label-position="top"
        hide-required-asterisk
      >
        <el-form-item
          prop="account"
          :rules="[
            { required: true, message: '请输入用户名', trigger: 'blur' },
          ]"
        >
          <span slot="label">
            <i class="el-icon-user" />
            账户
          </span>
          <el-input v-model="userInfo.account" />
        </el-form-item>
        <el-form-item
          prop="password"
          :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]"
        >
          <span slot="label">
            <i class="el-icon-unlock" />
            密码
          </span>
          <el-input v-model="userInfo.password" type="password" />
        </el-form-item>
        <el-form-item>
          <el-button class="subBtn" type="primary" @click="submit"
            >登陆</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { apiLogin } from "@/api/auth";
import CryptoJS from "crypto-js";

export default {
  data() {
    return {
      userInfo: {
        account: "administrator_test_0001",
        password: "123456789",
      },
    };
  },
  methods: {
    submit() {
      this.$refs.dynamicValidateForm.validate((o) => {
        if (!o) return this.$message("表单验证失败");

        apiLogin({
          ...this.userInfo,
          password: this.encrypt(this.userInfo.password),
        }).then((res) => {
          const { data } = res;
          if (!data.success) {
            return Promise.reject(data.message);
          }

          localStorage.setItem(
            "token",
            data.data.token_type + " " + data.data.access_token
          );

          this.$message.success("登录成功");
          this.$router.push("/");
        });
      });
    },
    encrypt(word) {
      const key = CryptoJS.enc.Utf8.parse("530e3865aabd415f931301f92f714b3d"); // 密钥 后端提供
      const iv = CryptoJS.enc.Utf8.parse(""); // 偏移量
      const srcs = CryptoJS.enc.Utf8.parse(word);
      const encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100%;
  height: 100%;
  background: url("~@/assets/img/login-bg.png") center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;

  .login-box {
    width: 464px;
    height: 577px;
    background: url("~@/assets/img/login-box-bg.png") center/cover no-repeat;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    &-title {
      color: #fff;
      font-size: 30px;
      position: absolute;
      top: 15%;
    }

    .el-form {
      width: 80%;

      :deep(.el-form-item__label) {
        padding: 0;
        font-size: 16px;
      }

      :deep(.el-input__inner) {
        background-color: transparent;
        border: 1px solid #2085a7;
      }

      .subBtn {
        width: 100%;
        background-color: #08b9f4;
        border: none;
        padding: 16px;
        color: #fff;
      }
    }
  }
}
</style>
